import { createContext } from 'react';
import { initialContext } from './Calendar.constants';
import { tCalendarContext } from './Calendar.types';

export const CalendarContext = createContext<tCalendarContext>(initialContext);
